export const SET_CURRENT_WEEK = "SET_CURRENT_WEEK";
export const SET_TIMESHEET_STATUS = "SET_TIMESHEET_STATUS";
export const SET_TIMESHEET_LOCATION = "SET_TIMESHEET_LOCATION";

export const TIMESHEET_ROSTER_FETCH_REQUEST = "TIMESHEET_ROSTER_FETCH_REQUEST";
export const TIMESHEET_ROSTER_FETCH_SUCCESS = "TIMESHEET_ROSTER_FETCH_SUCCESS";
export const TIMESHEET_ROSTER_FETCH_FAILURE = "TIMESHEET_ROSTER_FETCH_FAILURE";
export const TIMESHEET_ROSTER_RESET = "TIMESHEET_ROSTER_RESET";
export const TIMESHEET_RESET = "TIMESHEET_RESET";
